var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.57 66.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #231916;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30D9\\u30FC\\u30B9",
    "data-name": "\\u30D9\\u30FC\\u30B9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 2,
    width: 57.57,
    height: 62.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.46,
    y1: 12.21,
    x2: 49.4,
    y2: 12.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.46,
    y1: 22.42,
    x2: 49.4,
    y2: 22.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.46,
    y1: 32.62,
    x2: 49.4,
    y2: 32.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.46,
    y1: 42.83,
    x2: 49.4,
    y2: 42.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.46,
    y1: 53.04,
    x2: 49.4,
    y2: 53.04
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billing_icon.d081c904908be2f8e5120a3b18a0f08f.svg";
export { ForwardRef as ReactComponent };